subscribe(PUB_SUB_EVENTS.quantityUpdate, (data) => {
  const freeSeatsText = document.getElementById('course-free-seats');
  if (!freeSeatsText) {
    return;
  }

  const quantityInputs = document.getElementsByClassName('quantity__input');
  if (quantityInputs.length === 0) {
    return;
  }

  const quantityInput = quantityInputs[0];
  const max = quantityInput.getAttribute("max");
  if (max === "") {
    return;
  }

  freeSeatsText.getElementsByClassName('free_seats')[0].innerHTML = max;
});
